import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FEATURE_CUSTOM_PAYMENT, FEATURE_CUSTOM_REDUX } from "../../../constant";
import { cancelMySubscription, getMySubscription } from "../../paymentRequest";
import PackageList from "./PackageList";

import {
    Stack,
    Typography,
    Button,
    styled,
    Grid
} from "@mui/material";
import moment from "moment";
import ConfirmationAlert from "./ConfirmationAlert"
import { messages } from "./messages";
import ButtonLoader from "./helperComponent/ButtonLoader"
import { NotificationType } from "./Utils";
import { setNotificationMessage, setSubscriptionPackage } from "./payment-reducer/actions";
import { ct, dynamicMessageLocale } from "../../../constant-Utils";
import Loader from 'react-loader';
import i18next from "i18next";
import { getBaseConfig } from "../../../Utils";
import { PushSpinner } from "../../../custom/components/PushSpinner";
import { usePrevious } from "../../Utils";


const StyledTypography = styled(Typography)({
    '&.MuiTypography-root': {
        fontSize: "16px",
        mb: 1,
        color: "#333"
    }
});
const Subscription = (props) => {
    let curTime = Math.round(new Date().getTime() / 1000);

    const dispatch = useDispatch();

    const {
        userPaymentSubscription
    } = useSelector(state => state[FEATURE_CUSTOM_PAYMENT])

    const [userSubscription, setUserSubscription] = useState(false)

    const [isConfirming, setIsConfirming] = useState(false)

    const [isLoading, setIsLoading] = useState(false);

    const [UIrefresh, setUIrefresh] = useState(false);

    const [isLanguageChanged, setIsLanguageChanged] = useState(false);
    const { showLoader } = useSelector((state) => state[FEATURE_CUSTOM_REDUX])

    let language = usePrevious(i18next.language)
    useEffect(() => {
        if (language && language != i18next.language) {
            console.log("language changed or init")
            setIsLanguageChanged(true);
            let timer = null;
            if (timer) {
                clearTimeout(timer);
            };
            timer = setTimeout(() => {
                setIsLanguageChanged(false);
            }, 2000)
        }
    }, [i18next.language])

    useEffect(() => {
        let hasSubscription = false;
        if (userPaymentSubscription.pack_id) {
            hasSubscription = true;
            if (userPaymentSubscription.is_canceled == false) {
                if (userPaymentSubscription.end_at < curTime) {
                    hasSubscription = false;
                } else {
                    hasSubscription = true;
                }
            } else {
                hasSubscription = false;
            }
        }
        setUserSubscription(hasSubscription)


        // if

        // setAdditionalProps()
    }, [])

    const handleCancelSubscription = () => {
        setIsConfirming(true)
    }

    const formatDate = (unixtime) => <>{moment.unix(unixtime).locale('en').format("YYYY-MM-DD hh:mm A")}</>

    const handleConfirmAction = (type) => {
        setIsConfirming(false)
        if (type) {
            setIsLoading(true)
            cancelMySubscription({
                subscription_id: userPaymentSubscription.subscription_id,
                coupon_code_id: userPaymentSubscription?.coupon_code_id || undefined
            }).then(async (resp) => {
                setUIrefresh(true)
                if (resp.status == 1) {
                    dispatch(getMySubscription())
                }
                setUIrefresh(true)
                setIsLoading(false)
                let msg = await dynamicMessageLocale(resp.message);
                dispatch(setNotificationMessage({
                    isOpen: true,
                    type: resp.status == 1 ? NotificationType.SUCCESS : NotificationType.ERROR,
                    message: msg
                }));
                setTimeout(() => {
                    dispatch(setNotificationMessage({
                        isOpen: false,
                        type: null,
                        message: null
                    }));
                }, 5000)
            })
        }
    }
    if (isLanguageChanged) {
        if (getBaseConfig("showPushSpinnerLoader")) {
            return <div className="loader-text-container F">
                <div className='loader-wrapper'>
                    <PushSpinner
                        size={30}
                        color="white"
                        loading={false}
                        className={"loader-text-main"}
                    />
                </div>
            </div>
        } else {
            return <Loader
                loaded={true}
                options={{
                    color: '#fff'
                }}
                className={"loader-text-main"}
            > </Loader>
        }
    }

    return (
        <>
            {isConfirming && <ConfirmationAlert handleConfirmAction={handleConfirmAction} title={ct("rta-trmc.dashboard.subscription.cancelSubscriptionMsg")} />}
            <PackageList
                isLoading={isLoading}
                handleCancelSubscription={handleCancelSubscription}
                showPackageOnly={false}
                pad={0}
                UIrefresh={UIrefresh}
                socialTrigger = {props.socialTrigger}
            />
        </>
    )
}

export default Subscription;